<template>
  <v-sheet rounded="lg" class="mb-2" :color="is_today ? 'white' : 'grey-lighten-1'" width="100%" style="position: relative;">
    <v-icon class="replace-observers" :icon="['fas', 'shuffle']" v-if="day_observer_1 && day_observer_2" v-on:click="replace_observers()"/>


    <v-sheet
        class="d-flex justify-center align-center"
        rounded="lg"
        color="transparent"
        height="30"
        width="100%"
        style="font-size: 10px; color: #000; transition: 0.3s; position: relative"
        :style="day_observer_1 ? `font-weight: bolder;`: null "
    >
      <v-sheet
          class="d-flex justify-center align-center"
          color="green"
          rounded="lg"
          style="position: absolute"
          width="100%" height="100%"
          v-if="available_observer() && not_old"
          v-on:dragover="dragOver__Specialist"
          v-on:dragleave="dragLeave__Specialist"
          v-on:drop="dropEvent__Specialist"
          :id="`observer_1_${ moment(day.date).format('YYYY-MM-DD') }`"
      >
        {{ day_observer_1 ? initials(day_observer_1) : "+" }}
      </v-sheet>
      {{ day_observer_1 ? initials(day_observer_1) : 'ДЕЖУРСТВО НЕ НАЗНАЧЕНО' }}
      <v-icon v-if="day_observer_1 && not_old" class="delete-observer-icon" :icon="['fas', 'trash']" v-on:click="delete_observer(1)"/>
    </v-sheet>

    <v-sheet
        v-if="day_observer_1"
        class="d-flex justify-center align-center"
        rounded="lg"
        color="transparent"
        height="30"
        width="100%"
        style="font-size: 10px; color: #000; transition: 0.3s;  position: relative"
    >
      <v-sheet
          color="green"
          rounded="lg"
          style="position: absolute"
          width="100%" height="100%"
          v-if="available_observer() && not_old"
          class="d-flex justify-center align-center"
          v-on:dragover="dragOver__Specialist"
          v-on:dragleave="dragLeave__Specialist"
          v-on:drop="dropEvent__Specialist"
          :id="`observer_2_${ moment(day.date).format('YYYY-MM-DD') }`"
      >
        {{ day_observer_2 ? initials(day_observer_2) : "+" }}
      </v-sheet>
      {{ day_observer_2 ? initials(day_observer_2) : 'ДОП. ДЕЖУРНЫЙ НЕ НАЗНАЧЕН' }}
      <v-icon v-if="day_observer_2 && not_old" class="delete-observer-icon" :icon="['fas', 'trash']" v-on:click="delete_observer(2)"/>
    </v-sheet>
  </v-sheet>

  <v-sheet
      :min-height="day_observer_1 ? '81vh' : '84vh'"
           style="overflow: auto; position: relative"
           color="transparent"
           :class="{ 'full' : day.is_full, 'disable_scroll' :  event__type === 'document'}"
           class="day_cell" rounded="lg"
           :id="`day_cell_${day.date}`"
  >
    <v-sheet
        class="d-flex justify-center align-start day-available"
        :id="`day_${ moment(day.date).format('YYYY-MM-DD') }`"
        v-on:dragover="dragOver__Day"
        v-on:dragleave="dragLeave__Day"
        v-on:drop="dropEvent__Day(day)"
        v-if="available_day(day)"
        rounded="lg"
        position="absolute" width="100%" height="100%"
        style="z-index: 3000; font-size: 30px; display: flex; color: #4f4f4f !important; transition: 0.3s; backdrop-filter: blur(2px)"
    >
      +
    </v-sheet>


    <v-sheet v-for="(element, index) in filtered" :key="element" style="position: relative" color="transparent">
      <v-sheet
          class="d-flex justify-center align-center event-available"
          v-on:dragover="dragOver__Specialist"
          v-on:dragleave="dragLeave__Specialist"
          v-on:drop="dropEvent__Specialist"
          :id="`event_${element.__ID}`"
          v-if="available_event(element)"
          rounded="lg"
          position="absolute" width="100%" height="100%"
          color="transparent"
          style="font-size: 30px; color: #4f4f4f !important; transition: 0.3s; z-index: 10000; backdrop-filter: blur(2px)"
      >
        +
      </v-sheet>


      <v-sheet
          :draggable="is_draggable(element) && !element.permanent"
          :color="is_today ? 'rgba(231,241,232,0.78)' : 'grey-lighten-2'"
          rounded="lg" elevation="0"
          :class="{'not_draggable' : !is_draggable(element), 'mb-1' : index !== filtered.length-1, 'selected_info' : info && info.__ID === element.__ID}"
          class="event_card pa-1"

          v-on:dragstart="dragStart__Event(element)"
          v-on:dragend="dragEnd__Event"
          v-on:click="set_info(element)"
      >
        <p style="font-size: 10px; text-align: center; margin-top: -5px; opacity: 0.5;">
              <span v-if="element.worktype">
                {{ element.worktype.name }}
              </span>
        </p>
        <v-sheet class="d-flex justify-space-between align-start" width="100%" color="transparent">
          <v-sheet style="position: absolute; top: 0; right: 0;" color="transparent">
            <DeleteEvent__WP_Dialog :event="element" v-if="is_draggable(element) && element.is_duplicated" />
          </v-sheet>

          <v-avatar :color="element.doc_type === 'Обращение' ? 'green' : 'grey-lighten-4'" class="mr-1" size="25" style="font-size: 8px;">
            <span v-if="element.doc_type === 'Обращение'">ОБР</span>
            <span v-if="element.doc_type === 'Проведение ТО и ППР'">ТО</span>
          </v-avatar>

          <p style="font-size: 12px;">
            <span v-if="element.doc_type === 'Проведение ТО и ППР'">З.Н. </span>
            {{ element.number }} <v-icon :icon="['fas', 'check']" v-if="element.permanent" /><br>
            <span style="opacity: 0.5; font-size: 12px;">{{ element.duration }} ч/ч</span>
          </p>
          <v-spacer />
          <p style="font-size: 14px;" class="ml-2">
            <span>{{ element.object.name }}</span>
            <span v-if="element.location.guid">- {{ element.location.name }}</span>
          </p>
        </v-sheet>

        <v-sheet color="transparent" class="d-flex justify-start align-start flex-wrap" v-if="element.persons && element.persons.length > 0">
          <Specialist__Mini_InfoCard v-if="element.persons && is_draggable(element)" v-model="element.persons" :day="day" />
        </v-sheet>
      </v-sheet>
    </v-sheet>
  </v-sheet>
</template>

<script>
import moment from "moment/moment"
import { CurrentElement, CurrentElement__Data, CurrentElement__Dst, EventsList } from "@/store/wp_planner/events.store"
import {InfoBlock, MiniInfoBlock} from "@/store/wp_planner/info.store"
import { Specialists, WeekDura } from "@/store/wp_planner/specialists.store"
import { App_Documents, Reg_Documents } from "@/store/wp_planner/documents.store"
import Specialist__Mini_InfoCard from "@/components/wp_planner/info_cards/specialist.minimized.ic.vue"
import { Mai_Documents } from "@/store/wp_planner/documents/maintenance.store";
import DeleteEvent__WP_Dialog from "@/components/wp_planner/dialogs/delete_event.dialog.vue";
import { Del_Documents } from "@/store/wp_planner/documents/deleted.store";
import { FiltersBlock } from "@/store/wp_planner/filters.store";
import { Allerts, Info } from "@/store/global/Allerts";
import { Observers } from "@/store/wp_planner/misc.store";
import { initials } from "../../../libs/utils";

export default {
  name: "Body__WP_Calendar",
  components: { DeleteEvent__WP_Dialog, Specialist__Mini_InfoCard },
  props: ['index', 'day'],
  data() {
    return {
      moment: moment,
      colored: []
    }
  },
  methods: {
    initials,
    set_info: function (element) {
      this.info = element
      this.info_mini = null
    },
    get_observers: function () {
      return this.observers.find(el => moment(el.day).format('DDMMYYYY') === moment(this.day.date).format('DDMMYYYY'))
    },
    is_draggable: function (document) {
      if (['2. Решено', '2. Закрыто'].includes(document.status.name)) return false
      return true
    },
    replace_observers: function () {
      let observer_day = this.observers.find(el => moment(el.day).format('DDMMYYYY') === moment(this.day.date).format('DDMMYYYY'))
      let tmp = observer_day.stobserver
      observer_day.stobserver = observer_day.observer
      observer_day.observer = tmp

    },
    delete_observer: function (observer_type) {
      let observer_day = this.observers.find(el => moment(el.day).format('DDMMYYYY') === moment(this.day.date).format('DDMMYYYY'))
      if (observer_type === 1) {
        observer_day.stobserver = null
        if (observer_day.observer) {
          observer_day.stobserver = observer_day.observer
          observer_day.observer = null
        }
      } else if (observer_type === 2) {
        observer_day.observer = null
      }
    },
    /*duplicate_event: function (document) {
      document = JSON.parse(JSON.stringify(document))
      let new_id = document.guid+'_'+moment(document.date.desire)
      document.__ID = new_id
      document.persons = []

      this.all_events.push(document)
    },*/
    all_observers_not_used: function (observer_day) {
      let array_of_e = this.event__data.map(() => { return false })
      for (let [index, observer] of this.event__data.entries()) {
        array_of_e[index] = observer_day.stobserver !== observer && observer_day.observer !== observer;
      }
      return array_of_e.every( v => v === true )
    },
    available_observer: function () {
      let observer_day = this.observers.find(el => moment(el.day).format('DDMMYYYY') === moment(this.day.date).format('DDMMYYYY'))
      if (this.event__type !== 'specialist') return false
      let all_specialists_not_used = this.all_observers_not_used(observer_day)
      if (!all_specialists_not_used) return false
      let all_specialists_can_work_in_this_day = this.all_specialists_can_work_in_this_day()
      if (!all_specialists_can_work_in_this_day) return false
      return true
    },
    available_day: function (day) {
      if (this.event__type !== 'document') return false
      if (!this.check_persons()) return false
      if (moment(day.date).startOf('day') < moment().startOf('day')) return false
      if (this.events.filter(ev => ev.guid === this.event__data.guid).length > 0) return false
      return true
    },
    available_event: function (element) {
      if (this.event__type !== 'specialist') return false
      let all_specialists_not_used = this.all_specialists_not_used(element)
      if (!all_specialists_not_used) return false
      let all_specialists_can_work_in_this_day = this.all_specialists_can_work_in_this_day()
      if (!all_specialists_can_work_in_this_day) return false
      return true
    },
    check_persons: function () {
      let spec = this.event__data.persons
      let res = []
      for (let specialist of spec) {
        let specialist_from_list = this.specialists[this.specialists.findIndex(el => el.guid === specialist)]
        if (specialist_from_list) {
          let sepc_stat = specialist_from_list.days[moment(this.day.date).weekday()]
          res.push(sepc_stat)
        } else {
          res.push(true)
        }
      }
      let a = res.every(v => v === true)
      return !!a;
    },
    all_specialists_can_work_in_this_day: function () {
      let date = moment(this.day.date).weekday()
      let array_of_e = this.event__data.map(() => { return false })
      for (let [index, specialist] of this.event__data.entries()) {
        let specialist_from_list = this.specialists[this.specialists.findIndex(el => el.guid === specialist)]
        array_of_e[index] = specialist_from_list.days[date]
      }
      return array_of_e.every( v => v === true )
    },
    all_specialists_not_used: function (ev) {
      let array_of_e = this.event__data.map(() => { return false })
      for (let [index, specialist] of this.event__data.entries()) {
        array_of_e[index] = ev.persons.findIndex(el => el === specialist) === -1
      }
      return array_of_e.every( v => v === true )
    },
    dropEvent__Day: function (day) {
      event.preventDefault()
      if (event.target.classList.contains('day-hovered')) {
        let date = moment(event.target.id.replace('day_', ''))
        this.remove_form_src(this.event__dst, this.event__data)
        this.event__data.date.desire = date.format('YYYY-MM-DD[T]HH:mm:ss')
        this.event__data.__ID = this.event__data.guid+"_"+this.event__data.date.desire
        this.all_events.push(this.event__data)
        event.target.classList.remove('day-hovered')
        this.colored = []
        let hours = this.week_ext_data[moment(day.date).weekday()-1]

        if (parseFloat(this.event__data.duration) + parseFloat(day.used) > hours) {
          Info().warn(
              'ВНИМАНИЕ',
              `${ moment(day.date).format('DD.MM.YYYY') } недостаточно ресурсов для выполнения данной задачи, требуется скорректировать планы!`,
              '#d54a0f',
              'wp__day_overflow' ,
              'triangle-exclamation'
          )
        }
      }
    },
    dropEvent__Specialist: function () {
      event.preventDefault()
      if (event.target.classList.contains('event-hovered')) {
        let e = this.all_events[this.all_events.findIndex(el => el.__ID === event.target.id.replace('event_', ''))]
        e.persons.push(...this.event__data)
        event.target.classList.remove('event-hovered')
      }

      if (event.target.classList.contains('observer-hovered')) {
        let array = event.target.id.split('_')
        let date = moment(array[2])

        let observer_day = this.observers.find(el => moment(el.day).format('DDMMYYYY') === date.format('DDMMYYYY'))

        if (this.event__data.length > 2) {
          Allerts().warn('ОШИБКА', 'В данный раздел можно поместить не более двух сотрудников!', 'red', 'triangle-exclamation')
        } else if (this.event__data.length === 2) {
          observer_day.stobserver =  this.event__data[0]
          observer_day.observer =  this.event__data[1]
        } else if (this.event__data.length === 1) {
          if (array[1] === "1") {
            observer_day.stobserver =  this.event__data[0]
          } else {
            observer_day.observer =  this.event__data[0]
          }
        }
        event.target.classList.remove('observer-hovered')
      }
    },
    dragOver__Day: function () {
      if (this.event__type === 'document') {
        if (event.target.id.includes('day_')) {
          if (!event.target.classList.contains('full')) {
            event.target.classList.add('day-hovered')
            event.preventDefault()
          }
        }
      }
    },
    dragOver__Specialist: function () {
      if (this.event__type === 'specialist') {
        if (event.target.id.includes('event_')) {
          event.target.classList.add('event-hovered')
          event.preventDefault()
        }
        if (event.target.id.includes('observer_')) {
          event.target.classList.add('observer-hovered')
          event.preventDefault()
        }
      }
    },
    dragLeave__Day: function () {
      event.preventDefault()
      if (event.target.classList.contains('day-hovered')) {
        event.target.classList.remove('day-hovered')
      }
    },
    dragLeave__Specialist: function () {
      event.preventDefault()
      if (event.target.classList.contains('event-hovered')) {
        event.target.classList.remove('event-hovered')
      }
      if (event.target.classList.contains('observer-hovered')) {
        event.target.classList.remove('observer-hovered')
      }
    },
    dragStart__Event: function (draggable) {
      this.event__type = 'document'
      this.event__dst = 'local'
      this.event__data = draggable
    },
    dragEnd__Event: function () {
      event.preventDefault()
      this.event__type = null
      this.event__dst = null
      this.event__data = null
    },
    remove_form_src: function (location, data) {
      let src = ''
      switch (location) {
        case 'registered':
          src = 'docs__registered'
          break;
        case 'local':
          src = 'all_events'
          break;
        case 'appeals':
          src = 'docs__appeals'
          break;
        case 'maintenance':
          src = 'docs__maintenance'
          break;
        case 'deleted':
          src = 'docs__deleted'
          break;
      }

      if (src) {
        let index = this[src].findIndex(el => el.__ID === data.__ID)
        this[src].splice(index, 1)
      }
    },
  },
  computed: {
    /**
     *
     * READ-ONLY
     *
     * **/
    is_today() {
      return moment(this.day.date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
    },
    not_old() {
      return moment(this.day.date).startOf('day') >= moment().startOf('day')
    },
    day_observer_1() {
      if (this.observers && this.observers.length > 0) {
        let observer_day = this.observers.find(el => moment(el.day).format('DDMMYYYY') === moment(this.day.date).format('DDMMYYYY'))
        if (observer_day && observer_day.stobserver) {
          if (this.specialists && this.specialists.length > 0) {
            let spec = this.specialists.find(el => el.guid === observer_day.stobserver)
            if (spec && spec.name) {
              return spec.name.toUpperCase()
            } else {
              Allerts().warn(
                  `ВНИМАНИЕ: Найдено дежурство на ${ moment(this.day.date).format('DD.MM.YYYY') }!`,
                  `Старший дежурный, назначенный для дежурства не имеет возможности быть выгруженным,
                  проверьте график "График дежурств" и конфигурацию пользователей`,
                  'deep-orange',
                  'exclamation'
              )
              return false
            }
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    day_observer_2() {
      if (this.observers && this.observers.length > 0) {
        let observer_day = this.observers.find(el => moment(el.day).format('DDMMYYYY') === moment(this.day.date).format('DDMMYYYY'))
        if (observer_day && observer_day.observer) {
          if (this.specialists && this.specialists.length > 0) {
            let spec = this.specialists.find(el => el.guid === observer_day.observer)
            if (spec && spec.name) {
              return spec.name.toUpperCase()
            } else {
              Allerts().warn(
                  `ВНИМАНИЕ: Найдено дежурство на ${ moment(this.day.date).format('DD.MM.YYYY') }!`,
                  `Дежурный, назначенный для дежурства не имеет возможности быть выгруженным,
                  проверьте график "График дежурств" и конфигурацию пользователей`,
                  'deep-orange',
                  'exclamation'
              )
              return false
            }
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }

    },
    filtered() {
      let docs = this.events
      if (this.selected_filters.length > 0) {
        for (let filter of this.selected_filters) {
          docs = docs.filter(document => filter.data.includes(document[filter.id].guid))
        }
        return docs
      } else {
        return this.events
      }
    },
    selected_filters() {
      return FiltersBlock().selected()
    },
    events() {
      return this.all_events.filter(el => {
        if (el && el.date && el.date.desire) {
          return el.date.desire === this.day.date
        }
        return false
      })
    },
    /**
     *
     * READ-WRITE
     *
     * **/
    info_mini: {
      get() {
        return MiniInfoBlock().get()
      },
      set(value) {
        MiniInfoBlock().set(value)
      }
    },
    specialists: {
      get() {
        return Specialists().get()
      },
      set(value) {
        Specialists().set(value)
      }
    },
    observers: {
      get() {
        return Observers().get()
      },
      set(value) {
        Observers().set(value)
      }
    },
    docs__appeals: {
      get() {
        return App_Documents().get()
      },
      set(value) {
        App_Documents().set(value)
      }
    },
    docs__registered: {
      get() {
        return Reg_Documents().get()
      },
      set(value) {
        Reg_Documents().set(value)
      }
    },
    docs__maintenance: {
      get() {
        return Mai_Documents().get()
      },
      set(value) {
        Mai_Documents().set(value)
      }
    },
    docs__deleted: {
      get() {
        return Del_Documents().get()
      },
      set(value) {
        Del_Documents().set(value)
      }
    },
    week_ext_data: {
      get() {
        return WeekDura().get()
      },
      set(value) {
        WeekDura().set(value)
      }
    },
    info: {
      get() {
        return InfoBlock().get()
      },
      set(value) {
        InfoBlock().set(value)
      }
    },
    all_events: {
      get() {
        return EventsList().get()
      },
      set(value) {
        EventsList().set(value)
      }
    },
    event__dst: {
      get() {
        return CurrentElement__Dst().get()
      },
      set(value) {
        CurrentElement__Dst().set(value)
      }
    },
    event__data: {
      get() {
        return CurrentElement__Data().get()
      },
      set(value) {
        CurrentElement__Data().set(value)
      }
    },
    event__type: {
      get() {
        return CurrentElement().get()
      },
      set(value) {
        CurrentElement().set(value)
      }
    }
  }
}
</script>

<style scoped>
.day-available {
  background: rgba(12, 157, 24, 0.1);
}

.event-available {
  background: rgba(12, 157, 24, 0.1) !important;
}
.day-hovered {
  background: rgba(12, 157, 24, 0.26) !important;
}
.event-hovered {
  background: rgba(12, 157, 24, 0.26) !important;
}

.not_draggable {
  opacity: 0.3;
}

.disable_scroll {
  overflow: hidden !important;
}

.selected_info {
  border: 2px #8ac149 dotted !important;
}

.event_card {
  border: 2px transparent solid;
}

.observer-hovered {
  background: #8ac149 !important;
}
.delete-observer-icon {
  position: absolute;
  right: 10px;
  cursor: pointer;
  transition: 0.3s;
}
.delete-observer-icon:hover {
  color: #9d0c0c;
  scale: 1.2;
}
.replace-observers {
  z-index: 2000;
  position: absolute;
  left: 10px;
  height: 15px;
  top: calc(50% - 7.5px);
  cursor: pointer;
  transition: 0.3s;
}
.replace-observers:hover {
  scale: 1.2;
}
</style>
